import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';

const ListSheetDimenion = props => {
  const [dimensions, setDimensions] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      sorter: true,
      ...filter('label'),
    },
    {
      title: 'AA Code',
      dataIndex: 'aa_code',
      key: 'aa_code',
      // sorter: true,
      ...filter('aa_code'),
    },
    {
      title: 'Size MM H',
      dataIndex: 'mm_height',
      key: 'mm_height',
      // sorter: true,
      ...filter('mm_height'),
    },
    {
      title: 'Size MM W',
      dataIndex: 'mm_width',
      key: 'mm_width',
      // sorter: true,
      ...filter('mm_width'),
    },
    {
      title: 'Size " H',
      dataIndex: 'height',
      key: 'height',
      // sorter: true,
      ...filter('height'),
    },
    {
      title: 'Size " W',
      dataIndex: 'width',
      key: 'width',
      // sorter: true,
      ...filter('width'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/negative-sheet-dimensions/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_negative_sheet_dimensions?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_negative_sheet_dimensions?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'sheet_dimensions',
              'Negative sheet dimension?',
              dimensions,
              setDimensions,
              props.tabs_permissions?.settings_negative_sheet_dimensions?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getDimensionData(pagination);
  })();
  }, []);

  const getDimensionData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('sheet_dimensions', {
        fields: ['id', 'label', 'aa_code', 'mm_height', 'mm_width', 'height', 'width', 'dim_classification', 'obj_classification'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setDimensions(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        val && (key == 'id' ? (filtersitems[key] = { _eq: val[0] }) : (filtersitems[key] = { _icontains: val[0] }));
      }
    }
    await getDimensionData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/negative-sheet-dimensions" }, { title: "Negative Sheet Dimensions" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Sheet Dimension
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions?.settings_negative_sheet_dimensions,
                '/settings/negative-sheet-dimensions/new',
                'Create Negative Sheet Dimension'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={dimensions}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ListSheetDimenion;
